<template>
	<div class="">
		<div class="row">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SALES" unit="B" div=1000000000 :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="WASTE" unit="M" div=1000000 :data="ytd.waste.rekap" itemcol="Info" valuecol="Value" comp=-1 url="/bright/sales"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SPD" unit="M" div=1000000 :data="ytd.sales.spd" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="MARGIN" unit="%" :data="ytd.margin.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
				</div>
				<div class="row" v-if="false">
					<div class="col-md-6">
						<BarCard title="SALES YTD (B)" :data="ytd.sales.ytdchart" :width="500" :height="280" url="/bright/sales" v-if="showchartstore"/>
					</div>
					<div class="col-md-6">
						<BarCard title="SALES MTD (B)" :data="ytd.sales.mtdchart" :width="500" :height="280" url="/bright/sales" v-if="showchartstore"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN YTD (%)" :data="ytd.margin.ytdchart" :width="500" :height="280" url="/bright/sales" v-if="showchartstore"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN MTD (%)" :data="ytd.margin.mtdchart" :width="500" :height="280" url="/bright/sales" v-if="showchartstore"/>
					</div>
				</div>		
				
				<div class="row">
					<div class="col-md-6 mb-4">
						<BarCard title="SALES WEEKLY (M)" :data="sales.weekly" :width="500" :height="400" v-if="showchartstore"/>
					</div>
					<div class="col-md-6 mb-4">
						<BarCard title="MARGIN WEEKLY (M)" :data="margin.weekly" :width="500" :height="400" v-if="showchartstore"/>
					</div>
				</div>
			</div>

			<div class="col-md-4" v-if="false">
				<div class="row">
					<ListItem title="STORES BY AREA" prefix="AREA" :data="store.area" itemcol="SalesArea" valuecol="StoreCnt"/>
					<ListItem title="STORES BY PROVINCE" :data="store.province" itemcol="ProvinceName" valuecol="StoreCnt"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, AppColors, Rainbow, Rainbow2 } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: Bright,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		//Footer            
	},
	props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
        branchid: {
            type: String,
            default: '',
            //required: false,
        },
		showchartstore: {
			type: Boolean,
			default: false,
		},
    },
	data() {
		return {
			//branchid: this.storeid,
			url: '',
			ytd: {
				sales:{rekap:[], spd:[], ytdchart:{}, mtdchart:{}, spdchart:{}, weekly: {} }, 
				margin:{rekap:[], ytdchart:{}, mtdchart:{}}, 
				waste:{rekap:[], ytdchart:{}, mtdchart:{}}, 
				reconcile:{rekap:[], ytdchart:{}, mtdchart:{}}, 
				basket:{invoice:[], size:[]}, 
				store:{rekap:[]},
			},
			store: {area:[], province:[], list:[]},
			sales: { weekly:{} },
			margin: { weekly:{} },

			stacked: false,
		}
	},
	watch:{
		branchid() { //(newVal, oldVal) {
			this.loadYTD();
			this.loadSalesYTD();
		}
	},
	mounted()
	{
		//this.loadYTD();
    },
	computed: {
		
	},
    methods:{
		async loadYTD() {
			let url = Config().apiURL + "/bright/ytd?" + (this.branchid ? "&branchid=" + this.branchid : "") + (this.branchid ? "&plant=" + this.plant : "")
			await AxiosWithJar().get(url).then(result => {
				if (result.data.sales.length) {
					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "TotalSPD", "StoreCount", "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.waste = {
						rekap: this.processYTD(result.data.waste, "Info", "Waste", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.waste, "Info", "", "Waste", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.waste, "Info", "", "Waste", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.reconcile = {
						rekap: this.processYTD(result.data.reconcile, "Info", "Reconcile", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.reconcile, "Info", "", "Reconcile", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.reconcile, "Info", "", "Reconcile", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};
					this.ytd.store = {
						rekap: this.processYTD(result.data.store, "Info", "TotalStore", false, "Grup", 1, 2),
					}

					//console.log('ytd sales bright ALL : ' + JSON.stringify(this.ytd.sales.rekap))
					//console.log('ytd sales bright: ' + JSON.stringify(this.ytd.sales.rekap[3]))
					//console.log("ytd.margin.rekap[3]: " + JSON.stringify(this.ytd.margin.rekap[3]));
					//console.log("ytd.margin.rekap: " + JSON.stringify(this.ytd.margin.rekap));

					this.redrawChart();
				}
			})
		},
		async loadSalesYTD(){
			let url =Config().apiURL+"/bright/sales?period=daily&detail=store"
				url += "&date-range-start="+Penanggalan().mingguSekarang
				url += "&date-range-end="+Penanggalan().kemarin
				url += (this.plant ? "&plant=" + this.plant : "") + (this.branchid ? "&branchid=" + this.branchid : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data) {
					/*
					this.sales.weekly = this.processBarChart2(result.data.data, 'BranchName', 'TotalSalesExTax', false, 'Period', 1000, 2, AppColors, 
						false, false, false, true, false, false, false, true);
					*/
					this.sales.weekly = this.processBarChart(result.data.data, "BranchName", "SALES ", "TotalSalesExTax", false, "Period", "", 1000, 2, AppColors, false, false, false, this.stacked);	

					/*
					this.margin.weekly = this.processBarChart2(result.data.data, 'BranchName', 'TotalMargin', false, 'Period', 1000, 2, AppColors, 
						false, false, false, true, false, false, false, true);
					*/
					this.margin.weekly = this.processBarChart(result.data.data, "BranchName", "MARGIN ", "TotalMargin", false, "Period", "", 1000, 2, AppColors, false, false, false, this.stacked);	

					this.redrawChart();
				}
			})
		},

		redrawChart() {
            this.showchartstore = false
            setTimeout(() => {
                this.showchartstore = true
                //console.log('Redraw chart growth')
            }, 500);
        },

	},

}

</script>